import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProvidersPage from "./pages/ProvidersPage";
import ProviderProfilePage from "./pages/ProviderProfilePage";
import ProfilePage from "./pages/ProfilePage";
import MyQuotesPage from "./pages/MyQuotesPage";
import SettingsPage from "./pages/SettingsPage";
import RequestQuotePage from "./pages/RequestQuotePage";
import ProQuotesPage from "./pages/ProQuotesPage";
import BecomeAProPage from "./pages/BecomeAProPage";
import PricingPage from "./pages/PricingPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import AdminDashboard from "./pages/AdminDashboard";
import PackageManagementPage from "./pages/PackageManagementPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import EditBusinessProfilePage from "./pages/EditBusinessProfilePage";
import InvoicesPage from "./pages/InvoicesPage";
import PendingInvoicePage from "./pages/PendingInvoicePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import FAQPage from "./pages/FAQPage";
import HelpPage from "./pages/HelpPage";
import TrustSafetyPage from "./pages/TrustSafetyPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import AccessibilityPage from "./pages/AccessibilityPage";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/providers" element={<ProvidersPage />} />
            <Route path="/provider/:id" element={<ProviderProfilePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/my-quotes" element={<MyQuotesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/request-quote" element={<RequestQuotePage />} />
            <Route path="/pro-quotes" element={<ProQuotesPage />} />
            <Route path="/become-a-pro" element={<BecomeAProPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/packages" element={<PackageManagementPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/edit-business-profile" element={<EditBusinessProfilePage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/pending-invoice" element={<PendingInvoicePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/trust-safety" element={<TrustSafetyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
